module.exports = __webpack_public_path__ + "img/d_plus.5783f523.svg";